module.exports = __webpack_public_path__ + "static/flags/UY-b3ca08444cc531c8d77f8f99b0a8d4ca.gif";